import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_BEGIN,
  DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_SUCCESS,
  DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_FAILURE,
  DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function createEnvironmentVariables(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/external-datasource/environments/constants`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateEnvironmentVariablesError() {
  return {
    type: DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_BEGIN:
      return {
        ...state,
        createEnvironmentVariablesPending: true,
        createEnvironmentVariablesError: null,
      };

    case DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_SUCCESS:
      return {
        ...state,
        createEnvironmentVariablesPending: false,
        createEnvironmentVariablesError: null,
      };

    case DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_FAILURE:
      return {
        ...state,
        createEnvironmentVariablesPending: false,
        createEnvironmentVariablesError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_DISMISS_ERROR:
      return {
        ...state,
        createEnvironmentVariablesError: null,
      };

    default:
      return state;
  }
}
